import { useState, useEffect } from "react";
import { useSnackbar } from "../context/SnackbarContext";
import "./Snackbar.css";

export const Snackbar = () => {
  const [showFadeOut, setShowFadeOut] = useState(false);
  const { isOpen, setIsOpen, snackbarType, message } = useSnackbar();

  const fadeStartDelay = 3000;
  const duration = 3000;
  const totalDuration = fadeStartDelay + duration;

  useEffect(() => {
    if (!isOpen) return;

    const fadeTimer = setTimeout(() => {
      setShowFadeOut(true);
    }, fadeStartDelay);

    const timer = setTimeout(() => {
      setIsOpen(false);
      setShowFadeOut(false);
    }, totalDuration);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(timer);
    };
  }, [isOpen, setIsOpen, totalDuration]);

  if (!isOpen) return;

  const icons = {
    success: {
      src: "success.png",
      alt: "success",
    },
    warning: {
      src: "warning.png",
      alt: "warning",
    },
    error: {
      src: "error.png",
      alt: "error",
    },
  };

  const typeLabels = {
    success: "Successo",
    error: "Errore",
    warning: "Attenzione",
  };

  return (
    <div className={`snackbar-container ${showFadeOut ? "fade-out" : ""}`}>
      <img
        src={icons[snackbarType].src}
        alt={icons[snackbarType].alt}
        className="snackbar-image"
      />

      <div className="snackbar-text-container">
        <span>{typeLabels[snackbarType]}!</span>

        <p className="snackbar-text">{message}</p>
      </div>

      <button className="snackbar-btn-close" onClick={() => setIsOpen(false)}>
        X
      </button>
    </div>
  );
};
